module.exports = __webpack_public_path__ + "img/first_view_arrow.cb4b7904.svg";